import { Icon, IconProps } from "..";

export const Uzi = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 56 56" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.6454 14.6621H41.3368V17.3269H44.0016V19.9916H46.6663V22.6831H38.6721V25.3478H28.013V30.6774H22.6835V41.3364H14.6625V25.3478H11.9978V22.6831H9.33301V17.3269H33.3159V14.6621H36.0073V17.3269H38.6454V14.6621ZM25.3216 25.3478H20.0187V27.9859H25.3216V25.3478Z"
        fill="currentColor"
      />
    </Icon>
  );
};
